const FIELD_BADGE: Record<string, string> = {
  class_name: 'bg-orange-100 text-orange-800',
  subject: 'bg-green-100 text-green-800',
  room: 'bg-yellow-100 text-yellow-800',
  ignore: 'bg-gray-100 text-gray-600',
  open: 'bg-rose-100 text-rose-800',
}

const FIELD_LABEL: Record<string, string> = {
  class_name: 'Klasse',
  subject: 'Fach',
  room: 'Raum',
  ignore: 'Ignorieren',
  open: 'Offen',
}

export function TokenFieldBadge({ field }: { field: string }) {
  return (
    <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${FIELD_BADGE[field] || 'bg-gray-100 text-gray-600'}`}>
      {FIELD_LABEL[field] || field}
    </span>
  )
}
